module.exports = __webpack_public_path__ + "img/Moon-and-Stars-Tattoo-idea.jpg";